import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleMacroActivities = {
  namespaced: true,

  state: {
    name: 'macroActivities',
    macroActivities: [],
    activities: []
  },

  mutations,
  getters,
  actions
}

export default moduleMacroActivities;